import MapControlLayer from "../MapControlLayer";

export default class AnnotationLayer extends MapControlLayer {
    constructor(id, dataStream, selectionDataStream, linkedHideable) {
        super(id, dataStream, selectionDataStream, linkedHideable);
    }

    getIconExpression(projectionProxy) {
        var expression = null;

        const zoomStops = [ 0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0 ];

        expression = ['step', ['zoom']];

        expression.push([ "get", "styleId" ]);

        for (var zoomStop of zoomStops) {
            const worldZoomStop = projectionProxy.toWorldZoom(zoomStop);
            const property = [ "get", this._zoomStopProperty(worldZoomStop, "styleId") ];

            expression.push(worldZoomStop, property);
        }

        return expression;
    }

    getIconScaleExpression(scalable, projectionProxy) {
        var expression = null;

        if (scalable) {
            const zoomStops = [ 0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0 ];

            expression = ['interpolate', ['linear'], ['zoom']];

            for (var zoomStop of zoomStops) {
                const worldZoomStop = projectionProxy.toWorldZoom(zoomStop);
                const property = [ "get", this._zoomStopProperty(worldZoomStop, "iconScale") ];

                expression.push(worldZoomStop, property);
            }
        } else {
            const worldZoomStop = projectionProxy.toWorldZoom(0);
            expression = ["get", this._zoomStopProperty(worldZoomStop, "iconScale") ];
        }

        return expression;
    }

    getIconOffsetArrayExpression(scalable, projectionProxy) {
        var expression = null;

        if (scalable) {
            const zoomStops = [ 0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0 ];

            expression = ['interpolate', ['linear'], ['zoom']];

            for (var zoomStop of zoomStops) {
                const worldZoomStop = projectionProxy.toWorldZoom(zoomStop);
                const property = [ "get", this._zoomStopProperty(worldZoomStop, "iconOffsetArray") ];

                expression.push(worldZoomStop);
                expression.push(property);
            }
        } else {
            const worldZoomStop = projectionProxy.toWorldZoom(0);
            expression = ["get", this._zoomStopProperty(worldZoomStop, "iconOffsetArray") ];
        }

        return expression;
    }
}